import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AIConsultingPage = lazy(() => import('../pages/services/ai-consulting/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const HowWeWorkPage = lazy(() => import('../pages/how-we-work/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const MilwaukeePage = lazy(() => import('../pages/service-areas/milwaukee/page'));
const MadisonPage = lazy(() => import('../pages/service-areas/madison/page'));
const GreenBayPage = lazy(() => import('../pages/service-areas/green-bay/page'));
const TradesPage = lazy(() => import('../pages/industries/trades/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const AIStaffProductivityWisconsinPage = lazy(() => import('../pages/ai-staff-productivity-wisconsin/page'));
const AIMarketingAutomationWisconsinContractorsPage = lazy(() => import('../pages/ai-marketing-automation-wisconsin-contractors/page'));
const WisconsinBusinessCommunityPage = lazy(() => import('../pages/wisconsin-business-community/page'));
const BookPage = lazy(() => import('../pages/book/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/ai-consulting',
    element: <AIConsultingPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/how-we-work',
    element: <HowWeWorkPage />,
  },
  {
    path: '/service-areas',
    element: <ServiceAreasPage />,
  },
  {
    path: '/service-areas/milwaukee',
    element: <MilwaukeePage />,
  },
  {
    path: '/service-areas/madison',
    element: <MadisonPage />,
  },
  {
    path: '/service-areas/green-bay',
    element: <GreenBayPage />,
  },
  {
    path: '/industries/trades',
    element: <TradesPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/ai-staff-productivity-wisconsin',
    element: <AIStaffProductivityWisconsinPage />,
  },
  {
    path: '/ai-marketing-automation-wisconsin-contractors',
    element: <AIMarketingAutomationWisconsinContractorsPage />,
  },
  {
    path: '/wisconsin-business-community',
    element: <WisconsinBusinessCommunityPage />,
  },
  {
    path: '/book',
    element: <BookPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
